export const API_URL = 'https://api.gill-cote-bistro.fr';
export const TOKEN_KEY = 'strapi-jwt-token';
